import DealerMapper from '../../utils/dealer-mapper.js';

export default class DealerLastViewed {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.fad-last-viewed');
        this.script = parent.el.querySelector('#dealer-last-viewed');
        this.template = _.template(this.script.innerHTML.replaceAll('\\', ''));
        this.api = this.script.dataset.api;
        this.key = this.script.dataset.key;
        this.background = parent.background;
        this.dealerId = window.localStorage[this.key];
        this.dealer = {};
    }

    show(){
        if (this.dealerId) {
            this.dealerId !== this.dealer.uri ? this.get(this.dealerId) : this.populate();
        } else {
            this.el.classList.add('hide');
            this.background.show();
        }
    }

    hide(){
        this.el.classList.add('hide');
        this.background.hide();
    }

    get(dealer) {
        this.data = new FormData();
        this.data.append('dealer', dealer);

        fetch(this.api, { method: 'POST', body: this.data })
            .then((response) => response.json())
            .then((dealer) => this.dealer = DealerMapper.map(dealer))
            .then(() => this.populate())
            .catch((error) => this.background.show());
    }

    populate() {
        const dealer = this.dealer;
        const chooseDealerAriaLabelTemplate = this.el.dataset.chooseDealerAriaLabel;
        dealer.chooseDealerAriaLabel = chooseDealerAriaLabelTemplate.replace(/\{0\}/g, dealer.name);
        this.el.innerHTML = this.template({ dealer });
        this.el.classList.remove('hide');
        this.background.hide();
    }
}
